import React from 'react'
import { Table, Space, Button, Tooltip, Typography, Tag, theme } from 'antd'
import { EditOutlined, CheckOutlined } from '@ant-design/icons'
import { formatDateTime, getDuration, getStatusBadge, getCategoryTag, getEventTypeTag } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const { Text } = Typography

const EventsTable = ({ data }) => {
  const { token } = theme.useToken()

  const columns = [
    {
      title: 'Event ID',
      dataIndex: 'eventId',
      key: 'eventId',
      width: 120
    },
    {
      title: 'Theatre Room',
      dataIndex: 'theatreRoom',
      key: 'theatreRoom',
      sorter: (a, b) => a.theatreRoom.localeCompare(b.theatreRoom)
    },
    {
      title: 'Event Type',
      dataIndex: 'eventType',
      key: 'eventType',
      render: (text) => getEventTypeTag(text)
    },
    {
      title: 'Category',
      dataIndex: 'eventCategory',
      key: 'eventCategory',
      render: (category) => getCategoryTag(category)
    },
    {
      title: 'Details',
      dataIndex: 'eventDetails',
      key: 'eventDetails',
      render: (text, record) => (
        <Space direction='vertical' size={0}>
          <Text>{text}</Text>
          {record.patientName && (
            <Text type='secondary' style={{ fontSize: '12px' }}>
              Patient: {record.patientName} ({record.patientId})
            </Text>
          )}
        </Space>
      )
    },
    {
      title: 'Start Time',
      dataIndex: 'eventStart',
      key: 'eventStart',
      render: (date) => formatDateTime(date),
      sorter: (a, b) => new Date(a.eventStart) - new Date(b.eventStart)
    },
    {
      title: 'End Time',
      dataIndex: 'eventEnd',
      key: 'eventEnd',
      render: (date) => (date ? formatDateTime(date) : '-')
    },
    {
      title: 'Duration',
      key: 'duration',
      render: (_, record) => getDuration(record.eventStart, record.eventEnd)
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => getStatusBadge(status)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size='small'>
          <Tooltip title='View Details'>
            <Button
              icon={<EditOutlined style={{ color: token.colorPrimary }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorPrimary, 0.1),
                borderColor: token.colorPrimary
              }}
            />
          </Tooltip>
          {record.status === 'In Progress' && (
            <Tooltip title='Mark as Complete'>
              <Button
                icon={<CheckOutlined style={{ color: token.colorSuccess }} />}
                size='small'
                style={{
                  background: hexToRGBA(token.colorSuccess, 0.1),
                  borderColor: token.colorSuccess,
                  color: token.colorSuccess
                }}
              >
                Complete
              </Button>
            </Tooltip>
          )}
        </Space>
      )
    }
  ]

  return <Table columns={columns} dataSource={data} rowKey='eventId' pagination={{ pageSize: 10 }} />
}

export default EventsTable
